<template>
  <div class="cat-selector">
    <cat-attribute-select
      :label="label"
      :hint="hint"
      :placeholder="placeholder"
      v-bind="$attrs"
      :value="value"
      :mandatory="true"
      :errors="errors"
      @ui-change="onChange"
    >
    </cat-attribute-select>

    <slot></slot>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";
export default defineComponent({
  name: "CatSelector",
  props: {
    id: {
      type: [String, Number]
    },
    value: {
      type: [String, Number]
    },
    label: [String],
    hint: [String],
    placeholder: [String],
    errors: [Array]
  },
  methods: {
    onChange: function (evt) {
      this.$emit("ui-change", {
        event: evt,
        id: this.id ? this.id : null,
        value: evt.value,
        el: this.$el
      });
    }
  }
});
</script>
